// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"b323743e","787":"748a8cd4"}[chunkId] + ".chunk.js";
};